import drowsiness from '../../../../../assets/icons/Drowsiness.svg';
import distracted from '../../../../../assets/icons/Distracted.svg';
import phoneCalling from '../../../../../assets/icons/phone-calling.svg';
import potentialCollision from '../../../../../assets/icons/Plus Stroke.svg';
import harshBraking from '../../../../../assets/icons/Hard Braking.svg';
import farwardCollision from '../../../../../assets/icons/Forward Collision.svg';
import sos from '../../../../../assets/icons/SOS.svg';
import driverUnauthorized from '../../../../../assets/icons/unauthorizedDriver.svg';
import cameraBlock from '../../../../../assets/icons/Camera Block.svg';
import laneDeparture from '../../../../../assets/icons/Location.svg';
import vulnerableRoadUser from '../../../../../assets/icons/vulnerableRoadAlert.svg';
import harshAcceleration from '../../../../../assets/icons/Harsh Acceleration.svg';
import harshTurning from '../../../../../assets/icons/Harsh Turning.svg';
import overSpeeding from '../../../../../assets/icons/Over Speeding.svg';
import vehicleIdealing from '../../../../../assets/icons/VideoPlaybutton.svg';
import continuousDriving from '../../../../../assets/icons/ContinuousDrivingReport.svg';
import nightDriving from '../../../../../assets/icons/NightDrivingEvent.svg';
import smoking from '../../../../../assets/icons/Smoking.svg';
import seatBelt from '../../../../../assets/icons/Alarm.svg';
import yawing from '../../../../../assets/icons/Alarm.svg';

export const warningIcons = [
  { warningName: 'Drowsiness', iconName: drowsiness },
  { warningName: 'Distracted', iconName: distracted },
  { warningName: 'Phone Calling', iconName: phoneCalling },
  { warningName: 'Harsh Braking', iconName: harshBraking },
  { warningName: 'Forward Collision', iconName: farwardCollision },
  { warningName: 'SOS', iconName: sos },
  { warningName: 'Unauthorized Driver', iconName: driverUnauthorized },
  { warningName: 'Camera Block', iconName: cameraBlock },
  { warningName: 'Lane Departure', iconName: laneDeparture },
  { warningName: 'Vulnerable Road User', iconName: vulnerableRoadUser },
  { warningName: 'Harsh Acceleration', iconName: harshAcceleration },
  { warningName: 'Harsh Turning', iconName: harshTurning },
  { warningName: 'Over Speeding', iconName: overSpeeding },
  { warningName: 'Vehicle Idling', iconName: vehicleIdealing },
  { warningName: 'Continuous Driving', iconName: continuousDriving },
  { warningName: 'Night Driving', iconName: nightDriving },
  { warningName: 'Smoking', iconName: smoking },
  { warningName: 'Seat Belt', iconName: seatBelt },
  { warningName: 'Yawning', iconName: yawing },
];

export const getWarningIcon = (warning: string | null) => {
  const icon = warningIcons.find((icon) => icon.warningName === warning);
  return icon?.iconName;
};
